import React from "react"

interface StaticTimerProps {
  totalTime: number
  currentTime: number
  size?: "sm" | "md" | "lg" | "xl" | "2lg"
  showLabel?: boolean
  labelText?: string
  className?: string
  timeClassName?: string
}

const StaticTimer: React.FC<StaticTimerProps> = ({
  totalTime,
  currentTime,
  size = "md",
  showLabel = true,
  labelText = "Time Left",
  className = "",
  timeClassName = "",
}) => {
  // Calculate size based on prop
  const sizeMap = {
    sm: {
      container: "sm:h-6 sm:w-6 w-8 h-8",
      text: " text-sm",
      label: "text-sm",
    },
    md: { container: "w-14 h-14", text: "text-xl", label: "text-lg" },
    lg: { container: "w-16 h-16", text: "text-2xl", label: "text-lg" },
    "2lg": { container: "w-24 h-24", text: "text-3xl", label: "text-lg" },
    xl: {
      container: "sm:w-36 sm:h-36 w-48 h-48",
      text: "text-3xl",
      label: "text-lg",
    },
  }

  // Calculate progress percentage
  const progress = (currentTime / totalTime) * 100

  // Determine color based on remaining time percentage
  const getColor = () => {
    const percentage = (currentTime / totalTime) * 100
    if (percentage > 66) return "#10B981" // Green
    if (percentage > 33) return "#F59E0B" // Yellow
    return "#EF4444" // Red
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`relative ${sizeMap[size].container}`}>
        <svg
          className="w-full h-full sm:drop-shadow-md drop-shadow-[2px_2px_4px_rgba(0,0,0,0.5)]"
          viewBox="0 0 36 36"
        >
          {/* Background circle */}
          <path
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke="#E5E7EB"
            strokeWidth="3"
          />
          {/* Progress circle */}
          <path
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke={getColor()}
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray={`${progress}, 100`}
            style={{ transition: "stroke-dasharray 0.9s linear, stroke 0.4s ease" }}
          />
        </svg>
        <span
          className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${sizeMap[size].text} font-bold text-orange-black ${timeClassName}`}
        >
          {currentTime}
        </span>
      </div>
      {showLabel && (
        <div className="flex flex-col">
          <span
            className={`${sizeMap[size].label} font-semibold text-orange-black`}
          >
            {labelText}
          </span>
          <span className="text-sm text-orange-black/80">Seconds</span>
        </div>
      )}
    </div>
  )
}

export default StaticTimer
